<template>
    <VcPopover
        placement="top"
        trigger="hover"
        data-test-name="tooltip-refresh"
    >
        <template #reference>
            <VcButton
                data-test-name="button-refresh"
                icon="refresh-cw"
                type="outline"
                color="primary"
                :loading="loading"
                :disabled="disabled"
                v-bind="$attrs"
                @click="$emit('click', $event)"
            />
        </template>
        <div class="p-3">
            {{ t(tooltipText) }}
        </div>
    </VcPopover>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VcPopover, VcButton } from '@voicenter-team/voicenter-ui-plus'

const { t } = useI18n()

defineOptions({
    inheritAttrs: false
})

withDefaults(
    defineProps<{
        loading?: boolean
        disabled?: boolean
        tooltipText?: string
    }>(),
    {
        loading: false,
        disabled: false,
        tooltipText: 'refresh.filter.data'
    }
)

defineEmits<{
    (e: 'click', event: MouseEvent): void
}>()
</script>
